import noImage from "../../../images/NoImage.jpg";
import videoImage from "../../../images/thumbVideo.png";

import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import ImageComponent from "../shared/ImageComponent";
import LightGallery from "lightgallery/react";
import VideoPreview from "./videoPreview";
import lgVideo from "lightgallery/plugins/video";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css"; // The video plugin's CSS
import "lightgallery/css/lg-zoom.css";

const AnnonceImageList = ({offer}) => {
  const {FileUploads, id} = offer || {};

  // FileUploads.push(FileUploads[0]);
  const videos = FileUploads?.filter((image) => image.format === "VIDEO") || [];
  const images = FileUploads?.filter((file) => file.format !== "VIDEO") || [];
  return (
    <>
      {/* LightGallery for images only */}
      <LightGallery
        plugins={[lgVideo, lgZoom]}
        settings={{
          videojs: true,
          videojsTheme: "city",
          controls: true,
        }}
        elementClassNames="gap-2 w-full flex flex-wrap justify-start items-start"
      >
        {FileUploads?.length ? (
          FileUploads.map((image, index) => {
            if (index < 3 || FileUploads.length <= 4) {
              return image.format === "VIDEO" ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  key={image.id}
                  data-video={`{"source": [{"src": "${buildImageUrl(
                    image?.path,
                  )}", "type": "video/mp4"}], "attributes": {"controls": true}}`}
                  data-sub-html="<h4>Video Preview</h4>"
                  className=" rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover cursor-pointer "
                >
                  <img
                    className=" rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover cursor-pointer"
                    src={videoImage}
                    alt="video thumbnail"
                  />
                </a>
              ) : (
                <ImageComponent
                  key={image?.id}
                  src={buildImageUrl(image?.path)}
                  className="rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover cursor-pointer"
                  alt="annonce"
                  fallback={
                    <img
                      alt="annonce"
                      src={noImage}
                      className="rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover"
                    />
                  }
                />
              );
            } else if (index === 3 && FileUploads.length > 4) {
              return image.format === "VIDEO" ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  key={image.id}
                  data-video={`{"source": [{"src": "${buildImageUrl(
                    image?.path,
                  )}", "type": "video/mp4"}], "attributes": {"controls": true}}`}
                  data-sub-html="<h4>Video Preview</h4>"
                  className=" relative rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover cursor-pointer "
                >
                  <span className="absolute z-20 font-bold text-lg text-white top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    {`+${FileUploads.length - 3}`}
                  </span>
                  <img
                    className=" w-full rounded-lg aspect-square object-cover filter brightness-50"
                    src={videoImage}
                    alt="video thumbnail"
                  />
                </a>
              ) : (
                <a
                  key={image?.id}
                  href={buildImageUrl(image?.path)}
                  className="relative rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover cursor-pointer"
                >
                  <span className="absolute z-20 font-bold text-lg text-white top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    {`+${FileUploads.length - 4}`}
                  </span>
                  <ImageComponent
                    src={buildImageUrl(image?.path)}
                    className="w-full rounded-lg aspect-square object-cover filter brightness-50"
                    alt="annonce"
                    fallback={
                      <img
                        alt="annonce"
                        src={noImage}
                        className="rounded-lg border border-solid border-[#e2e2e2] w-full h-full object-cover filter brightness-50"
                      />
                    }
                  />
                </a>
              );
            }
          })
        ) : (
          <img
            alt="annonce"
            src={noImage}
            className="rounded-lg border border-solid border-[#e2e2e2] w-16 lg:w-14 2xl:w-16 aspect-square object-cover"
          />
        )}
      </LightGallery>
    </>
  );
};

export default AnnonceImageList;
